import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Headline from '../../ui/Headline';
import { GAME_DB } from '../../db/game';
import { getAtomFormattedDate, getMediaType } from '../../helpers';
import TaskAnswerButton from '../../ui/TaskAnswerButton';
import Input from '../../ui/Input';
import Select from '../../ui/Select';
import TaskStatusView from '../../components/TaskStatusView';
import { getGameState, sendTaskAnswersTimeLogsList } from '../../api/game-mode/game';
import { useSelector } from 'react-redux';
import { selectCurrentTaskTimeLogs, setCurrentTaskTimeLogs, setGame, setTaskStatus, } from '../../store/slices/rallyGame';
import { useAppDispatch } from '../../store';
import 'leaflet/dist/leaflet.css';
import { MAX_FILE_UPLOAD_SIZE_MB, MAX_IMAGE_UPLOAD_SIZE_MB, USER_UPLOAD_IMAGE_COMPRESSION_SIZE_MB, } from '../../app.config.vars/stored';
import LocationCheckIn from '../LocationCheckIn';
import Loader from '../../ui/Loader';
import FileUploader from '../../components/FileUploader';
import TextContent from '../../ui/TextContent';
const GameTask = ({ taskInfo, taskResult, selectionTaskAnswers, onSelectionTaskAnswerButtonClick, inputTaskAnswer, onInputTaskAnswerChange, uploadPhotoTaskAnswer, onUploadPhotoTaskAnswerChange, onTargetLocationCheckedIn, showTaskResult, onTryAgainButtonClick, taskAnswerValidationErrors, showLoader, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const currentTaskTimeLogs = useSelector(selectCurrentTaskTimeLogs);
    const [playerSelectedAnswerId, setPlayerSelectedAnswerId] = useState(null);
    const [checkedIn, setCheckedIn] = useState(false);
    useEffect(() => {
        setCheckedIn(false);
    }, [taskInfo]);
    useEffect(() => {
        const handleCurrentTimeLogs = async () => {
            if (currentTaskTimeLogs) {
                const timeLogs = {
                    task: currentTaskTimeLogs.taskUid,
                    startTime: currentTaskTimeLogs.startTime,
                    endTime: getAtomFormattedDate(Date.now()),
                };
                const updateLocal = async () => {
                    const gameTasks = await GAME_DB.GET.gameTasks();
                    if (gameTasks?.length) {
                        const currentTask = gameTasks.find((task) => task.uid === currentTaskTimeLogs.taskUid);
                        if (currentTask) {
                            await GAME_DB.UPDATE.taskStatus({
                                uid: currentTaskTimeLogs.taskUid,
                                status: currentTask.taskType === 'information' ? 'completed' : 'skipped',
                            });
                            dispatch(setTaskStatus({
                                taskUid: currentTaskTimeLogs.taskUid,
                                status: currentTask.taskType === 'information' ? 'completed' : 'skipped',
                            }));
                        }
                    }
                };
                const response = await sendTaskAnswersTimeLogsList({
                    timeLogs: [timeLogs],
                });
                if (!response.error) {
                    const gameState = await getGameState();
                    if (gameState.data) {
                        await GAME_DB.UPDATE.gameState(gameState.data);
                        dispatch(setGame(gameState.data));
                    }
                    else {
                        await updateLocal();
                    }
                }
                else {
                    await GAME_DB.UPDATE.pushAnswerTimeLogs(timeLogs);
                    await updateLocal();
                }
            }
        };
        const handleNewTimeLogs = () => {
            if (taskResult.status !== 'completed') {
                dispatch(setCurrentTaskTimeLogs({
                    taskUid: taskInfo.uid,
                    startTime: getAtomFormattedDate(Date.now()),
                }));
            }
            else {
                dispatch(setCurrentTaskTimeLogs(null));
            }
        };
        const handleTimeLogs = async () => {
            await handleCurrentTimeLogs();
            handleNewTimeLogs();
        };
        if (taskInfo) {
            if (currentTaskTimeLogs?.taskUid === taskInfo.uid) {
                return;
            }
            else {
                handleTimeLogs();
            }
        }
    }, [taskInfo]);
    useEffect(() => {
        if (taskInfo.answerType === 'player-selection') {
            const selectedAnswerId = selectionTaskAnswers?.find((answer) => answer.isSelected)?.uid;
            if (selectedAnswerId) {
                setPlayerSelectedAnswerId(String(selectedAnswerId));
            }
            else {
                setPlayerSelectedAnswerId(null);
            }
        }
    }, [selectionTaskAnswers]);
    return showTaskResult ? (_jsx(TaskStatusView, { taskResultStatus: taskResult.status === 'failed'
            ? 'failed'
            : taskInfo.answerType === 'location'
                ? 'success-location'
                : taskInfo.answerType === 'single-selection' ||
                    taskInfo.answerType === 'multiple-selection'
                    ? 'success-answer'
                    : 'success', onTryAgainButtonClick: onTryAgainButtonClick, points: taskResult.playerAnswers.length
            ? taskResult.playerAnswers[taskResult.playerAnswers.length - 1].pointsEarned
            : null })) : (_jsx("div", { className: 'game-task', children: showLoader ? (_jsx(Loader, {})) : (_jsxs(_Fragment, { children: [_jsx(Headline, { title: taskInfo.questionTitle, type: 'h1' }), !!taskInfo.mediaBase64 && (_jsxs("div", { className: "task-media", children: [getMediaType(taskInfo.mediaBase64) === 'image' && (_jsx("img", { alt: 'task information image', src: taskInfo.mediaBase64 })), getMediaType(taskInfo.mediaBase64) === 'video' && (_jsx("video", { src: taskInfo.mediaBase64 }))] })), taskInfo.questionDescription && (_jsx("div", { className: "task-description", children: _jsx(TextContent, { content: taskInfo.questionDescription, html: true }) })), taskInfo.answerType === 'multiple-selection' && (_jsx("div", { className: "task-answer-note", children: t('note.multiple_selection') })), (taskInfo.answerType === 'single-selection' ||
                    taskInfo.answerType === 'multiple-selection' ||
                    taskInfo.answerType === 'player-selection') &&
                    selectionTaskAnswers &&
                    onSelectionTaskAnswerButtonClick && (_jsx("div", { className: "task-answers", children: taskInfo.answerType === 'player-selection' ? (_jsx("div", { className: "task-answers-select", children: _jsx(Select, { placeholder: t('placeholder.select-team-member'), options: selectionTaskAnswers.map((answer) => ({
                                label: answer.content,
                                value: String(answer.uid),
                            })), onChange: (answerId) => {
                                onSelectionTaskAnswerButtonClick(+answerId);
                            }, defaultSelectedOptionValue: playerSelectedAnswerId, background: 'gray', size: 'large', disabled: !!playerSelectedAnswerId && taskResult.status === 'completed', error: !!taskAnswerValidationErrors.selectionTaskAnswer?.length, errorMessage: taskAnswerValidationErrors.selectionTaskAnswer?.length
                                ? t(taskAnswerValidationErrors.selectionTaskAnswer[0]
                                    .messageTranslationKey)
                                : undefined }) })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "task-answers-buttons-group", children: selectionTaskAnswers.map((answer) => (_jsx(TaskAnswerButton, { content: answer.content, isSelected: answer.isSelected, answerId: answer.uid, disabled: taskResult.status === 'completed', onAnswerClick: onSelectionTaskAnswerButtonClick }, answer.uid))) }), !!taskAnswerValidationErrors.selectionTaskAnswer?.length && (_jsx("div", { className: 'form-field-error-message', children: t(taskAnswerValidationErrors.selectionTaskAnswer[0].messageTranslationKey) }))] })) })), taskInfo.answerType === 'text' && onInputTaskAnswerChange && (_jsx("div", { className: 'task-answer-input', children: _jsx(Input, { id: `task-answer-input-${taskInfo.uid}`, value: inputTaskAnswer || '', onChange: onInputTaskAnswerChange, textarea: true, color: 'gray', placeholder: t('placeholder.enter_answer'), disabled: taskResult.status === 'completed', error: !!taskAnswerValidationErrors.inputTaskAnswer?.length, errorMessage: taskAnswerValidationErrors.inputTaskAnswer?.length
                            ? t(taskAnswerValidationErrors.inputTaskAnswer[0].messageTranslationKey, taskAnswerValidationErrors.inputTaskAnswer[0].variableToUseInMessage)
                            : undefined }) })), taskInfo.answerType === 'upload' && (_jsx("div", { className: 'task-answer-upload', children: _jsx(FileUploader, { useCamera: true, accept: 'image/*,.mp4,.mov,.mp3,.wav,.m4a,.3gp,.amr', buttonVariant: 'filled', selectedFile: uploadPhotoTaskAnswer, buttonLabel: t('button.open_gallery'), onChange: onUploadPhotoTaskAnswerChange, maxImageSizeMB: MAX_IMAGE_UPLOAD_SIZE_MB, maxFileSizeMB: MAX_FILE_UPLOAD_SIZE_MB, imageCompressionSizeMB: USER_UPLOAD_IMAGE_COMPRESSION_SIZE_MB, disabled: taskResult.status === 'completed', error: !!taskAnswerValidationErrors.photoUploadTaskAnswer?.length, errorMessage: taskAnswerValidationErrors.photoUploadTaskAnswer?.length
                            ? t(taskAnswerValidationErrors.photoUploadTaskAnswer[0].messageTranslationKey)
                            : undefined }) })), taskInfo.answerType === 'location' && (_jsx("div", { className: "task-answer-location", children: _jsx(LocationCheckIn, { targetLocation: { lat: taskInfo.coordinatesLat, lng: taskInfo.coordinatesLon }, radius: taskInfo.radius, onTargetCheckedIn: onTargetLocationCheckedIn, checkedIn: checkedIn, setCheckedIn: setCheckedIn }) }))] })) }));
};
export default GameTask;
